import { Box, Container, Text, VStack, Link, Flex } from "@chakra-ui/react"
import { Logo } from "@bleu/front/components/layout/Logo"

export const ShutdownPage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Box as="header" py={4} px={5} borderBottom="1px" borderColor="gray.100">
        <Container maxW="container.xl">
          <Logo />
        </Container>
      </Box>

      <Container
        maxW="container.md"
        flex="1"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={10}
      >
        <VStack spacing={6} align="start" fontSize="lg">
          <Text>La plateforme Bleu.care a cessé ses activités.</Text>
          <Text>
            Nous vous remercions sincèrement pour la confiance que vous nous
            avez accordée et pour la qualité des échanges entretenus au fil du
            temps.
          </Text>
          <Text>
            Avec toute notre gratitude,
            <br />
            L&apos;équipe Bleu
          </Text>
        </VStack>
      </Container>

      <Box as="footer" py={6} textAlign="center" bg="gray.50" />
    </Box>
  )
}
